const negotiationStatuses = {
  ongoing: "ongoing",
  accepted: "accepted",
  decline: "decline",
  timeout: "timeout",
  waiting: "waiting"
};

const negotiationStatusMapping = {
  0: negotiationStatuses.waiting,
  1: negotiationStatuses.ongoing,
  2: negotiationStatuses.accepted,
  3: negotiationStatuses.decline,
  4: negotiationStatuses.timeout,
};

export {
  negotiationStatuses,
  negotiationStatusMapping
};